import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';
import api from 'api';

export default class PdfDownload extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.state = { url: false, isLoading: false };
  }

  handlePdfDownload() {
    const { id } = this.props;

    this.setState({ isLoading: true });

    api.getInvoicePdf({ id })
      .then(({ body }) => {
        this.setState({ isLoading: false, url: body.data.attributes.url });
      });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <span
          className="button button--tiny"
        >
          Please wait...
        </span>
      );
    }

    if (this.state.url) {
      return (
        <a
          target="_blank"
          href={this.state.url}
          className="button button--primary button--tiny"
          rel="noopener noreferrer"
        >
          Download PDF
        </a>
      );
    }

    return (
      <button
        href="#"
        className="button button--tiny"
        onClick={this.handlePdfDownload.bind(this)}
      >
        Request PDF
      </button>
    );
  }
}




// WEBPACK FOOTER //
// ./app/components/PdfDownload.jsx